export { default as Independent } from './Independent';
